import { FunctionComponent } from 'react';
import cn from 'classnames';
import { ErrorCircle } from '@/components/common/icons/ErrorCircle';
import './Warning.scss';

interface Props {
  className?: string;
  message?: string;
}

export const Warning: FunctionComponent<Props> = ({ className, message }) => {
  return (
    <div className={cn('warning', className)}>
      <ErrorCircle className="warning__icon" />
      <span className="warning__text">{message}</span>
    </div>
  );
};
